import adapter from '../adapter-blog-tags';
var IDs = adapter.IDs, SchemaTypes = adapter.SchemaTypes;
export default {
    type: SchemaTypes.BLOG_TAGS_PAGE,
    schema: "{{" + IDs.SD_JSON_RENDER + "}}",
};
